// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SurveyStartSessionResponseModel {
    'surveySessionId'?: number;
    'firstQuestionId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SurveyStartSessionResponseModel>> = [
        {
            "name":     "surveySessionId",
            "baseName": "surveySessionId",
            "type":     "number"
        },
        {
            "name":     "firstQuestionId",
            "baseName": "firstQuestionId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return SurveyStartSessionResponseModel.attributeTypeMap;
    }
}
